module.exports = __webpack_public_path__ + "img/Tamale_Meal.b22bffff.jpg";